const selectSimilarAccountsGroups = (state) => state.similarAccountsGroups;
export const selectSimilarAccountsGroupsData = (state) => selectSimilarAccountsGroups(state).data;
export const selectSimilarAccountsGroupsTotal = (state) => selectSimilarAccountsGroups(state).total;
const selectSimilarAccounts = (state) => state.similarAccounts;
export const selectSimilarAccountsData = (state) => selectSimilarAccounts(state).data;
export const selectSimilarAccountsTotal = (state) => selectSimilarAccounts(state).total;
export const selectSimilarAccountsInfo = (state) => state.similarAccountsInfo;
